import React, { useState, useEffect, useContext } from 'react';
import { getWarehouses, shiftProduct } from '../../../Utility/Api';
import { toast } from 'react-toastify';
import { shop_id, warehouse_id } from '../../../Utility/function';
import { WarehouseContext } from '../../../Utility/UserContext';

const ShiftModal = ({ show, setShow, selectedItem, refreshList }) => {
    const { showLoader, hideLoader } = useContext(WarehouseContext);
    const [warehouses, setWarehouses] = useState([]);
    const [qty, setQty] = useState(0);
    const [selectedWarehouse, setSelectedWarehouse] = useState("");

    useEffect(() => {
        fetchWarehouse();
    }, []);

    const handleClear = () => {
        setQty(0);
        setSelectedWarehouse("");
        setShow(false);
    };

    const fetchWarehouse = async (page = 1, text = "") => {
        try {
            const response = await getWarehouses(page, text);
            if (response.data && response.data.data) {
                setWarehouses(response.data.data);
            }
        } catch (error) {
            console.error('Error fetching warehouses');
        }
    };

    const handleShift = async () => {
        try {
            if (!qty || !selectedWarehouse) {
                toast.error("Please enter quantity and select a warehouse");
                return;
            }

            showLoader();
            var payload = {
                id: selectedItem?.id,
                product_id: selectedItem?.product_id,
                warehouse_id: selectedWarehouse,
                qty: qty,
            }

            console.log("payload", payload);
            await shiftProduct(payload);
            toast.success("Product shifted successfully");
            handleClear();
            await refreshList();
            hideLoader();
        } catch (error) {
            hideLoader();
        }
    };

    return (
        <div
            className={`modal fade ${show ? "show" : ""}`}
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden={!show}
            style={{ display: show ? "block" : "none" }}
        >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                            <b>{selectedItem?.product_name}</b> - <b>{selectedItem?.warehouse_title}</b>
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            aria-label="Close"
                            onClick={handleClear}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label className="form-label">
                                Quantity{" "}
                                <span className="text-danger">
                                    (Max: {selectedItem?.remaining})
                                </span>
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                value={qty}
                                max={selectedItem?.remaining}
                                min={1}
                                onChange={(e) => {
                                    const value = parseInt(e.target.value);
                                    if (value <= selectedItem?.remaining) {
                                        setQty(value);
                                    }
                                }}
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label">Select Warehouse</label>
                            <select
                                className="form-select"
                                value={selectedWarehouse}
                                onChange={(e) => setSelectedWarehouse(e.target.value)}
                            >
                                <option value="">-- Select --</option>
                                {warehouses
                                    .filter((wh) => warehouse_id != wh.id)
                                    .map((wh) => (
                                        <option key={wh.id} value={wh.id}>
                                            {wh.title}
                                        </option>
                                    ))}
                            </select>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={handleClear}
                        >
                            Close
                        </button>
                        <button
                            type="button"
                            className="btn btn-primary"
                            onClick={handleShift}
                        >
                            Shift
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ShiftModal;
